import React, {useContext, useEffect, useState} from 'react';
import {MissionModelListContext} from "./MissionModelListContext";
import {WMSContext} from "../context/WMSContext";
import {getWMSPickingMissionModels} from "../../../api/wms/wmsTaskModel/list";
import {useHistory, useLocation} from "react-router-dom";
import update from "../../../api/wms/wmsTaskModel/update";
import {WMSRoutes} from "../../../utils/WMSRoutes";
import {deleteModel} from "../../../api/wms/wmsTaskModel/delete";
import {Authorizations} from "../../../utils/authorizations";
import ModelListMobile from "./components/ModelListMobile";
import ModelListDesktop from "./components/ModelListDesktop";
import DeleteMissionModelModal from "./components/DeleteMissionModelModal";
import Toast from "../../../components/WMS/Toast";
import {ReactComponent as ValidIcon} from "assets/img/validated.svg"
import {FormattedMessage} from "react-intl";

MissionModelListIndex.propTypes = {};

function MissionModelListIndex() {
    const {currentInventory, currentMemberAuthorizations, isMobile} = useContext(WMSContext)

    const [missionModels, setMissionModels] = useState([])
    const [selectedModel, setSelectedModel] = useState()
    const [openDeleteMissionModelModal, setOpenDeleteMissionModelModal] = useState(false)
    const [openValidModificationToast, setOpenValidModificationToast] = useState(false)
    const [loading, setLoading] = useState(false)

    const history = useHistory();

    const location = useLocation()
    const hasBeenModified = history.action === "PUSH" ? location.state?.hasChanged : null

    const init = () => {
        getWMSPickingMissionModels(currentInventory.id).then((response) => {
            setMissionModels(response)
        })
    }

    const handlePatchModel = (missionModel, data) => {
        update(missionModel, data)
            .then((response) => {
                let tempMissionModelsArray = [...missionModels];
                const index = tempMissionModelsArray.findIndex(model => model.id === missionModel.id);
                if (index !== -1) {
                    tempMissionModelsArray[index] = response;
                }

                setMissionModels(tempMissionModelsArray)
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            });
    }

    const handleEditeMissionModel = (missionModel) => {
        history.push(`${WMSRoutes.NEW_MISSION}/${missionModel.id}`)
    }

    const handleOpenDeleteMissionModelModal = (missionModel) => {
        setSelectedModel(missionModel)
        setOpenDeleteMissionModelModal(true)
    }

    const handleDeleteModel = () => {
        deleteModel(selectedModel).then(() => {
            setOpenDeleteMissionModelModal(false)
            init()
            setLoading(false)
        })
    }

    const handleCloseValidModificationToast = () => {
        setOpenValidModificationToast(false)
    }

    useEffect(() => {
        if (currentMemberAuthorizations && currentInventory) {
            if (!currentMemberAuthorizations.some(authorization => Authorizations.WMS_MANAGER === authorization)) {
                history.push(WMSRoutes.DASHBOARD)
                return;
            }

            init()
        }
    }, [currentInventory, currentMemberAuthorizations]);

    useEffect(() => {
        if (hasBeenModified) {
            setOpenValidModificationToast(true)
        }
    }, [hasBeenModified]);

    return (
      <MissionModelListContext.Provider value={{
          missionModels,
          selectedModel,
          openDeleteMissionModelModal,
          openValidModificationToast,
          loading,
          history,
          location,
          hasBeenModified,
          setSelectedModel,
          setOpenDeleteMissionModelModal,
          setOpenValidModificationToast,
          setLoading,
          handlePatchModel,
          handleEditeMissionModel,
          handleOpenDeleteMissionModelModal,
          handleDeleteModel,
          handleCloseValidModificationToast
      }}>
          {openDeleteMissionModelModal && (
          <DeleteMissionModelModal
              open={openDeleteMissionModelModal}
              handleClose={() => setOpenDeleteMissionModelModal(false)}
              missionModel={selectedModel}
              loading={loading}
              handleValid={() =>{
                  setLoading(true)
                  handleDeleteModel()
              }}
          />
          )}

          {openValidModificationToast && (
              <Toast
                  open={openValidModificationToast}
                  handleClose={handleCloseValidModificationToast}
                  icon={<ValidIcon />}
                  title={<FormattedMessage id={"wms.pickingMissionList.validModificationToast.title"}/>}
                  subtitle={<FormattedMessage id={"wms.pickingMissionList.validModificationToast.subtitle"} values={{modelName: hasBeenModified}}/>}
              />
          )}
          {isMobile && (
              <ModelListMobile/>
          )}

          {!isMobile && (
              <ModelListDesktop/>
          )}
      </MissionModelListContext.Provider>
    );
}

export default MissionModelListIndex;